// Smash — percussive impact: white flash, a single fast shockwave ring, and
// radial GLASS CRACKS that snap outward from the loser and hold before fading.
// Cracks are sector-based (seam-free) so there's no atan discontinuity line.
export const BRUTALITY_FRAG = /* glsl */ `
  precision mediump float;
  varying vec2 vUv;
  uniform float uTime;
  uniform float uDuration;
  uniform vec2 uAspect;
  uniform vec2 uCenter;

  float hash(vec2 p) {
    return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453);
  }

  void main() {
    vec2 uv = ((vUv - uCenter) * 2.0) * uAspect;
    float r = length(uv);
    float ang = atan(uv.y, uv.x);
    float t = clamp(uTime / uDuration, 0.0, 1.0);

    // Hard white flash, gone fast.
    float flash = exp(-9.0 * t);

    // Single fast shockwave ring, fades over the second half.
    float ringT = t * 1.9;
    float ring = 1.0 - smoothstep(0.0, 0.045, abs(r - ringT));
    ring *= (1.0 - smoothstep(0.5, 1.0, t));

    // Radial glass cracks. Sector index uses mod() so the -x seam lands on a
    // sector boundary — no visible left-hand line.
    float sectors = 16.0;
    float sa = (ang / 6.2831853 + 0.5) * sectors;
    float seg = floor(sa);
    float frac = fract(sa);
    float h = hash(vec2(mod(seg, sectors), 7.0));
    float center = 0.5 + (h - 0.5) * 0.7;          // crack offset in sector
    float lineW = 0.5 + 0.4 * hash(vec2(seg, 3.0));// jagged width
    float crackAng = 1.0 - smoothstep(0.0, 0.055 * lineW, abs(frac - center));
    float reach = 0.45 + 0.9 * hash(vec2(seg, 9.0));
    float grow = smoothstep(0.0, 0.16, t);          // snaps in fast
    float crackRad = 1.0 - smoothstep(reach * grow, reach * grow + 0.04, r);
    float cracks = crackAng * crackRad * (1.0 - smoothstep(0.6, 1.0, t));

    vec3 white = vec3(1.0);
    vec3 mint = vec3(0.063, 0.957, 0.545);
    vec3 col =
      white * flash +
      mix(mint, white, 0.6) * cracks * 1.4 +
      mix(white, mint, 0.5) * ring * 1.2;
    float alpha = clamp(flash + cracks * 1.2 + ring, 0.0, 1.0);
    gl_FragColor = vec4(col, alpha);
  }
`
